import { cancelData, saveData } from '../../util/FormUtil';
import { Box, Button, CircularProgress } from '@mui/material';
import { T } from '../../util/Localize';

export type ActionButtonsProps = {
    isDisabled?: boolean;
    isLoading?: boolean;
    isModified?: boolean;
    isSaving?: boolean;
    onCancel?: () => void;
    onSave?: any;
    state?: [any, (data: any) => void];
    active?: boolean;
    cancelLabel?: string;
    saveLabel?: string;
    isSaveDisabled?: boolean;
    /** When false, only the cancel (and optional children) row is shown. */
    showSaveButton?: boolean;
    children?: React.ReactNode;
    /**
     * Pinned to the far left of the row, opposite Cancel/Save — for actions that are not part of
     * the save flow and should not sit beside it, such as a destructive Delete. Omitted by default,
     * so the row stays right-aligned exactly as before.
     */
    leftContent?: React.ReactNode;
};

export default function ActionButtons(props: ActionButtonsProps) {
    const [data, setData] = props.state ? props.state : [null, () => {}];
    const isDisabled = props.isDisabled || false;
    const isLoading = props.isLoading || false;
    const showSaveButton = props.showSaveButton !== false;
    const modified = props.isModified || (data ? data.modified : false);
    const saving = data ? data.saving : props.isSaving || false;

    return (
        <Box
            display="flex"
            justifyContent={props.leftContent ? 'space-between' : 'flex-end'}
            alignItems="center"
            className={'animbuttons' + (modified || saving || props.active ? ' active' : '')}
            sx={{ my: 1 }}
        >
            {props.leftContent}
            {/* Keeps Cancel/Save together on the right once leftContent splits the row. */}
            <Box display="flex" alignItems="center">
            <Button
                variant="outlined"
                sx={{ mr: 2 }}
                disabled={isDisabled || isLoading}
                onClick={() => {
                    if (props.onCancel) {
                        props.onCancel();
                    }
                    if (props.state) {
                        cancelData(setData);
                    }
                }}
            >
                {T(props.cancelLabel || 'Cancel')}
            </Button>
            {props.children}
            {showSaveButton && (
                <Button
                    variant="contained"
                    color="primary"
                    disabled={isDisabled || isLoading || !modified || props.isSaveDisabled}
                    onClick={() => {
                        props.state ? saveData(setData, props.onSave) : props.onSave?.();
                    }}
                >
                    {!saving ? (
                        T(props.saveLabel || 'Save')
                    ) : (
                        <CircularProgress size={24} sx={{ color: 'inherit' }} />
                    )}
                </Button>
            )}
            </Box>
        </Box>
    );
}
